









import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

@Component({ name: 'AppError' })
export default class AppError extends Vue {
  @Prop({ type: String, default: '' })
  errMsg!: string;

  @Prop({ required: true })
  trigger!: any;
}
